function createLocalRouteFormatter(options) {
  return (config) => options.formatters?.[config.route]?.(config) || null;
}
export {
  createLocalRouteFormatter
};
//# sourceMappingURL=local.js.map
